var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasData)?_c('v-fade-transition',{key:"progress",attrs:{"mode":"out-in"}},[_c('v-progress-linear',{staticClass:"progress-linear-absolute--top",attrs:{"height":"2","indeterminate":""}})],1):_c('v-layout',{staticClass:"pa-4",attrs:{"justify-center":""}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }